module.exports = __webpack_public_path__ + "static/media/MPO_assemblies.745aae50.jpg";